import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

interface NotificationData {
    user_id: number;
    title: string;
    message: string;
    type: 'info' | 'success' | 'warning' | 'error';
    url?: string;
    data?: Record<string, any>;
}

const useNotificationService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingCreateNotification, setFetchingCreateNotification] = useState(false);
    const [fetchingGetNotificationsNotViewed, setFetchingGetNotificationsNotViewed] = useState(false);
    const [fetchingSetNotificationAsViewed, setFetchingSetNotificationAsViewed] = useState(false);

    const BASE_PATH = 'notifications/notifications';

    const getNotificationsNotViewed = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/not-viewed`),
            setFetching: setFetchingGetNotificationsNotViewed
        });
    };

    const setNotificationAsViewed = (notificationId: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${notificationId}/viewed`),
            body: {},
            setFetching: setFetchingSetNotificationAsViewed
        });
    };

    const createNotification = (notificationData: NotificationData, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/store`),
            body: notificationData,
            setFetching: setFetchingCreateNotification
        });
    };

    return {
        fetchingCreateNotification,
        fetchingGetNotificationsNotViewed,
        fetchingSetNotificationAsViewed,
        getNotificationsNotViewed,
        setNotificationAsViewed,
        createNotification,
    };
};

export default useNotificationService;